/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Include_Content1Inputs */

const en_pro_user_include_content1 = /** @type {(inputs: Pro_User_Include_Content1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS: Purchased the app from the App Store`)
};

const ar_pro_user_include_content1 = /** @type {(inputs: Pro_User_Include_Content1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS: شراء التطبيق من متجر App`)
};

const de_pro_user_include_content1 = /** @type {(inputs: Pro_User_Include_Content1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS: Die App wurde im App Store gekauft`)
};

const es_pro_user_include_content1 = /** @type {(inputs: Pro_User_Include_Content1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS: Compra de la app en la tienda de apps`)
};

const fr_pro_user_include_content1 = /** @type {(inputs: Pro_User_Include_Content1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS : Application achetée sur l'App Store`)
};

const it_pro_user_include_content1 = /** @type {(inputs: Pro_User_Include_Content1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS: Acquistata l'app dall'App Store`)
};

const ja_pro_user_include_content1 = /** @type {(inputs: Pro_User_Include_Content1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS：App Storeでアプリを購入された方`)
};

const ko_pro_user_include_content1 = /** @type {(inputs: Pro_User_Include_Content1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS: 앱스토어에서 앱을 구매한 사용자`)
};

const pt_br_pro_user_include_content1 = /** @type {(inputs: Pro_User_Include_Content1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS: adquiriram o aplicativo na App Store`)
};

const ru_pro_user_include_content1 = /** @type {(inputs: Pro_User_Include_Content1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS: купил приложение в App Store`)
};

const th_pro_user_include_content1 = /** @type {(inputs: Pro_User_Include_Content1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS: ซื้อแอปผ่าน App Store`)
};

const tr_pro_user_include_content1 = /** @type {(inputs: Pro_User_Include_Content1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS: Uygulamayı App Store'dan satın aldım`)
};

const zh_cn_pro_user_include_content1 = /** @type {(inputs: Pro_User_Include_Content1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS 在 App Store 付费下载`)
};

const zh_tw_pro_user_include_content1 = /** @type {(inputs: Pro_User_Include_Content1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS 在 App Store 付費下載`)
};

/**
* | output |
* | --- |
* | "iOS: Purchased the app from the App Store" |
*
* @param {Pro_User_Include_Content1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_include_content1 = /** @type {((inputs?: Pro_User_Include_Content1Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Include_Content1Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_include_content1(inputs)
	if (locale === "ar") return ar_pro_user_include_content1(inputs)
	if (locale === "de") return de_pro_user_include_content1(inputs)
	if (locale === "es") return es_pro_user_include_content1(inputs)
	if (locale === "fr") return fr_pro_user_include_content1(inputs)
	if (locale === "it") return it_pro_user_include_content1(inputs)
	if (locale === "ja") return ja_pro_user_include_content1(inputs)
	if (locale === "ko") return ko_pro_user_include_content1(inputs)
	if (locale === "pt_br") return pt_br_pro_user_include_content1(inputs)
	if (locale === "ru") return ru_pro_user_include_content1(inputs)
	if (locale === "th") return th_pro_user_include_content1(inputs)
	if (locale === "tr") return tr_pro_user_include_content1(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_include_content1(inputs)
	return zh_tw_pro_user_include_content1(inputs)
});